module.exports = __webpack_public_path__ + "static/socialie-by-ps-c36ffe5fc1f52401886330888d1c071d.png";